import { EquipmentSummaryReportStateTypes, EquipmentSummaryReportActionTypes } from "./EquipmentSummaryReport.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: EquipmentSummaryReportStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const EquipmentSummaryReportReducer = (
  state: EquipmentSummaryReportStateTypes = INITIAL_STATE,
  action: any
): EquipmentSummaryReportStateTypes => {
  switch (action.type) {
    case EquipmentSummaryReportActionTypes.FETCH_ALL_EQUIPMENT_SUMMARY_REPORT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case EquipmentSummaryReportActionTypes.FETCH_ALL_EQUIPMENT_SUMMARY_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EquipmentSummaryReportActionTypes.FETCH_ALL_EQUIPMENT_SUMMARY_REPORT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EquipmentSummaryReportActionTypes.FETCH_ALL_EQUIPMENT_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case EquipmentSummaryReportActionTypes.FETCH_ONE_EQUIPMENT_SUMMARY_REPORT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case EquipmentSummaryReportActionTypes.FETCH_ONE_EQUIPMENT_SUMMARY_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EquipmentSummaryReportActionTypes.FETCH_ONE_EQUIPMENT_SUMMARY_REPORT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EquipmentSummaryReportActionTypes.FETCH_ONE_EQUIPMENT_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default EquipmentSummaryReportReducer;
